import {
  WSActions,
  WSButton,
  WSElement,
  WSForm,
  WSInputMask,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import {
  MfaFactorCreateType,
  PersonMfaFactor
} from "@wingspanhq/wingspan-api-sdk";
import { ErrorAlert } from "@components/ErrorAlert";
import React from "react";
import * as Yup from "yup";
import { mfaCodePrompt } from "./mfaFactorLabel";

type FormData = { code: string };

type Props = {
  factor: PersonMfaFactor;
  submitting: boolean;
  resending: boolean;
  error?: unknown;
  onSubmit: (code: string) => void;
  onResend: () => void;
};

const validationSchema = Yup.object().shape({
  code: Yup.string()
    .required("Verification code is required")
    .matches(/^\d{6}$/, "Enter the 6-digit code")
});

export const MfaCodeForm: React.FC<Props> = props => {
  const canResend = props.factor.type !== MfaFactorCreateType.TOTP;

  return (
    <WSForm<FormData>
      onSubmit={data => props.onSubmit(data.code)}
      validationSchema={validationSchema}
      defaultValues={{ code: "" }}
    >
      <WSList gap="XL">
        <WSText color="gray600">{mfaCodePrompt(props.factor)}</WSText>

        <WSForm.Field
          name="code"
          label="Verification code"
          component={WSInputMask}
          componentProps={{
            mask: "999999",
            slotChar: "",
            autoComplete: "one-time-code"
          }}
        />

        <ErrorAlert error={props.error} context="MfaChallenge" />

        <WSActions
          buttons={[
            {
              label: "Verify",
              type: "submit",
              fullWidth: true,
              loading: props.submitting
            }
          ]}
        />

        {canResend ? (
          <WSElement>
            <WSText color="gray500" align="center" mb="M">
              Didn't receive it?
            </WSText>
            <WSButton.Secondary
              size="S"
              fullWidth
              type="button"
              loading={props.resending}
              onClick={props.onResend}
            >
              Resend code
            </WSButton.Secondary>
          </WSElement>
        ) : null}
      </WSList>
    </WSForm>
  );
};
